import { z } from "src/lib";
import { OperacionAFOPUFields, OperacionAFOPUTablaValorFields, OperacionAFOPUTablaValorHistoricoFields, OperacionAFOSectorComercialFields, OperacionAFOUnidadNegocioFields } from "./fields";
import { schemaEntityWithId, schemaEntityWithIdAndDescription } from "src/types";
import { schemaStringOpcional } from "src/pages/sistema/types/types";

export const schemaOperacionAFOPUTablaValorInsert = z.object({
    [OperacionAFOPUTablaValorFields.IdOperacionAFOPU]: z.number().nullable().optional(),
    [OperacionAFOPUTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOPUTablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionAFOPUTablaValorFields.Valor]: z.string({ 
            invalid_type_error: 'El aforo es requerido',
            required_error: 'El aforo es requerido'
        }).nullable(),
});
export type OperacionAFOPUTablaValorInsert = z.infer<typeof schemaOperacionAFOPUTablaValorInsert>;

export const schemaOperacionAFOPUInsert = z.object({
    [OperacionAFOPUFields.CodPais]: z.number(),
    [OperacionAFOPUFields.CodUnidadNegocio]: z.number().nullable(),
    [OperacionAFOPUFields.CodSectorComercial]: z.number(),
    [OperacionAFOPUFields.FechaSolicitud]: z.date(),
    [OperacionAFOPUFields.FechaVencimiento]: z.date(),
    [OperacionAFOPUFields.Observaciones]: z.string().nullable().optional(),
    [OperacionAFOPUFields.TablaValores]: z.array(schemaOperacionAFOPUTablaValorInsert),
});
export type OperacionAFOPUInsert = z.infer<typeof schemaOperacionAFOPUInsert>;

export const schemaOperacionAFOPUTablaValorUpdate = z.object({
    [OperacionAFOPUTablaValorFields.Valor]: z.string({
        required_error: 'El valor es requerido.',
    }),
});
export type OperacionAFOPUTablaValorUpdate = z.infer<typeof schemaOperacionAFOPUTablaValorUpdate>;

export const schemaOperacionAFOPUTablaValorVista = z.object({
    [OperacionAFOPUTablaValorFields.IdOperacionAFOPU]: z.number(),
    [OperacionAFOPUTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOPUTablaValorFields.DescInstrumento]: z.string(),
    [OperacionAFOPUTablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionAFOPUTablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionAFOPUTablaValorFields.Valor]: z.string(),
    [OperacionAFOPUTablaValorFields.OrdenInstrumento]: z.number(),
    [OperacionAFOPUTablaValorFields.OrdenOperacionTipo]: z.number(),
    [OperacionAFOPUTablaValorFields.PermiteEditar]: z.boolean().optional(),
}).merge(schemaEntityWithId);
export type OperacionAFOPUTablaValorVista = z.infer<typeof schemaOperacionAFOPUTablaValorVista>;


export const schemaOperacionAFOPUTablaValorVistaInicial = z.object({
    [OperacionAFOPUTablaValorFields.CodInstrumento]: z.number(),
    [OperacionAFOPUTablaValorFields.DescInstrumento]: z.string(),
    [OperacionAFOPUTablaValorFields.CodOperacionTipo]: z.number(),
    [OperacionAFOPUTablaValorFields.DescOperacionTipo]: z.string(),
    [OperacionAFOPUTablaValorFields.Valor]: z.string().nullable(),
    [OperacionAFOPUTablaValorFields.OrdenInstrumento]: z.number().nullable(),
    [OperacionAFOPUTablaValorFields.OrdenOperacionTipo]: z.number().nullable(),
    [OperacionAFOPUTablaValorFields.PermiteEditar]: z.boolean(),
});
export type OperacionAFOPUTablaValorVistaInicial = z.infer<typeof schemaOperacionAFOPUTablaValorVistaInicial>;


export const schemaOperacionAFOUnidadNegocio = z
    .object({

        [OperacionAFOUnidadNegocioFields.CodUnidadNegocio]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionAFOUnidadNegocio = z.infer<typeof schemaOperacionAFOUnidadNegocio>

export const schemaOperacionAFOSectorComercial = z
    .object({

        [OperacionAFOSectorComercialFields.CodSectorComercial]: z.number(),
    })
    .merge(schemaEntityWithIdAndDescription)
export type OperacionAFOSectorComercial = z.infer<typeof schemaOperacionAFOSectorComercial>


export const schemaOperacionAFOPUTablaValorHistorico = schemaOperacionAFOPUTablaValorVista.extend({
    [OperacionAFOPUTablaValorHistoricoFields.FechaModificacion]: z.coerce.date(),
    [OperacionAFOPUTablaValorHistoricoFields.NombreUsuarioModificacion]: z.string(),
    [OperacionAFOPUTablaValorHistoricoFields.Observaciones]: z.string().nullable().optional(),
});

export type OperacionAFOPUTablaValorHistorico = z.infer<typeof schemaOperacionAFOPUTablaValorHistorico>;

export const schemaOperacionAFOPUTablaValorHistoricoGrupo = z.object({
    [OperacionAFOPUTablaValorHistoricoFields.FechaModificacion]: z.coerce.date(),
    [OperacionAFOPUTablaValorHistoricoFields.NombreUsuarioModificacion]: z.string(),
    [OperacionAFOPUTablaValorHistoricoFields.Observaciones]: z.string().nullable().optional(),
    [OperacionAFOPUTablaValorHistoricoFields.Celdas]: z.array(schemaOperacionAFOPUTablaValorHistorico)
});

export type OperacionAFOPUTablaValorHistoricoGrupo = z.infer<typeof schemaOperacionAFOPUTablaValorHistoricoGrupo>;

export const schemaFormUpdateAFOPUTablaValores = z.object({
    observaciones: schemaStringOpcional,
    tablaValores: z.array(schemaOperacionAFOPUTablaValorVista),
});

export type FormUpdateAFOPUTablaValores = z.infer<typeof schemaFormUpdateAFOPUTablaValores>;
